import { render, staticRenderFns } from "./ChoiceList.vue?vue&type=template&id=a2e1f032&scoped=true"
import script from "./ChoiceList.vue?vue&type=script&lang=js"
export * from "./ChoiceList.vue?vue&type=script&lang=js"
import style0 from "./ChoiceList.vue?vue&type=style&index=0&id=a2e1f032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e1f032",
  null
  
)

export default component.exports